import { createMuiTheme } from '@material-ui/core/styles';
import { css } from '@emotion/core';


export const colour = {
  primary: '#0069C0',
  secondary: '#DDD',
  highlight: '#DDD',
  background: '#FAFAFA',
};

export const fontSize = {
  pageTitle: '32px',
  header: '26px',
  body: '16px',
};

const borderRadius = 8;

export const roundCorner = {
  all: `border-radius: ${borderRadius}px`,
  right: `border-radius: 0 ${borderRadius}px ${borderRadius}px 0`,
  left: `border-radius: ${borderRadius}px 0 0 ${borderRadius}px`,
  top: `border-radius: ${borderRadius}px ${borderRadius}px 0 0`,
  bottom: `border-radius: 0 0 ${borderRadius}px ${borderRadius}px`,
};

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: colour.primary,
      contrastText: colour.background,
    },
    secondary: {
      main: colour.secondary,
    },
  },
  typography: {
    fontFamily: [
      'Nova Mono',
      'monospace',
    ].join(','),
    fontSize: 20,
  },
});

export const globalStyles = css`
  body {
    background-color: ${colour.background};
  }
`;
